import React, { Component } from "react";
import "./AppBar.scss";
import Step1 from "./steps/Step1";
import Step2 from "./steps/Step2";
import Step3 from "./steps/Step3";
import Step4 from "./steps/Step4";
import WorkshopSearchModal from "./modals/WorkshopSearchModal";
import ModelSelectorModal from "./modals/ModelSelectorModal";
import TypeSelectorModal from "./modals/TypeSelectorModal";

export default class AppBar extends Component {
  constructor() {
    super();
    this.state = {
      showWorkshopSearchModal: false,
      showModelSelectorModal: false,
      showTypeSelectorModal: false
    };
  }

  modalWorkshopSearchToggle = () => {
    this.setState(prevState => ({
      showWorkshopSearchModal: !prevState.showWorkshopSearchModal,
      showModelSelectorModal: false,
      showTypeSelectorModal: false
    }));
  };

  modalModelSelectorToggle = () => {
    this.setState(prevState => ({
      showModelSelectorModal: !prevState.showModelSelectorModal,
      showWorkshopSearchModal: false,
      showTypeSelectorModal: false
    }));
  };

  modalTypeSelectorToggle = () => {
    this.setState(prevState => ({
      showTypeSelectorModal: !prevState.showTypeSelectorModal,
      showWorkshopSearchModal: false,
      showModelSelectorModal: false
    }));
  };

  render() {
    return (
      <div className="section-steps" id="app-bar-top">
        <div id="choose-model" className="container">
          <div className="row">
            <div className="col-md-1" />
            <div className="col-xs-12 col-md-10">
              <div className="section-steps__steps">
                <Step1
                  appBarState1={this.props.appBarState1}
                  modalWorkshopSearchToggle={this.modalWorkshopSearchToggle}
                  showWorkshopSearchModal={this.state.showWorkshopSearchModal}
                  selectedWorkshops={this.props.selectedWorkshops}
                />
                <Step2
                  appBarState2={this.props.appBarState2}
                  modalModelSelectorToggle={this.modalModelSelectorToggle}
                  showModelSelectorModal={this.state.showModelSelectorModal}
                  selectedModel={this.props.selectedModel}
                />
                <Step3
                  appBarState3={this.props.appBarState3}
                  modalTypeSelectorToggle={this.modalTypeSelectorToggle}
                  showTypeSelectorModal={this.state.showTypeSelectorModal}
                  distanceSelected={this.props.distanceSelected}
                />
                <Step4 appBarState4={this.props.appBarState4} />
                <div className="section-steps__rule" />
              </div>
            </div>
          </div>
        </div>

        <WorkshopSearchModal
          showWorkshopSearchModal={this.state.showWorkshopSearchModal}
          modalWorkshopSearchToggle={this.modalWorkshopSearchToggle}
          selectedWorkshops={this.props.selectedWorkshops}
          resetStateTo1={this.props.resetStateTo1}
        />
        <ModelSelectorModal
          showModelSelectorModal={this.state.showModelSelectorModal}
          modalModelSelectorToggle={this.modalModelSelectorToggle}
          selectedModel={this.props.selectedModel}
          resetModels={this.props.resetModels}
          redirectToCarRegistartion={this.props.redirectToCarRegistartion}
          plate={this.props.plate}
        />
        <TypeSelectorModal
          showTypeSelectorModal={this.state.showTypeSelectorModal}
          modalTypeSelectorToggle={this.modalTypeSelectorToggle}
          selectedModel={this.props.selectedModel}
          carInfo={this.props.carInfo}
          fuelSelected={this.props.fuelSelected}
          gearBoxNameSelected={this.props.gearBoxNameSelected}
          engineNameSelected={this.props.engineNameSelected}
          yearSelected={this.props.yearSelected}
          distanceSelected={this.props.distanceSelected}
          resetStateTo2={this.props.resetStateTo2}
        />
      </div>
    );
  }
}
